module.exports = __webpack_public_path__ + "img/icon-moon.e66b8c62.svg";